webpackJsonp([0],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SAVE_ELEMENTS_STORE = exports.SAVE_ELEMENTS_STORE = 'SAVE_ELEMENTS_STORE';
var MERGE_DATA_GEO = exports.MERGE_DATA_GEO = 'MERGE_DATA_GEO';
var CHANGE_CURRENT_KEY = exports.CHANGE_CURRENT_KEY = 'CHANGE_CURRENT_KEY';
var SAVE_SCALES = exports.SAVE_SCALES = 'SAVE_SCALES';
var CHANGE_CURRENT_SCALE = exports.CHANGE_CURRENT_SCALE = 'CHANGE_CURRENT_SCALE';
var CHANGE_PARAMETER_FILTER = exports.CHANGE_PARAMETER_FILTER = 'CHANGE_PARAMETER_FILTER';
var SAVE_DATA = exports.SAVE_DATA = 'SAVE_DATA';
var SAVE_DATA_GEO = exports.SAVE_DATA_GEO = 'SAVE_DATA_GEO';
var FETCH_SUCCESS = exports.FETCH_SUCCESS = 'FETCH_SUCCESS';
var FETCH_FAILURE = exports.FETCH_FAILURE = 'FETCH_FAILURE';

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentElementZoomed = undefined;
exports.callZoomMap = callZoomMap;

var _d3Selection = __webpack_require__(9);

var _zoom = __webpack_require__(580);

var _filters = __webpack_require__(581);

var _filters2 = _interopRequireDefault(_filters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = document.querySelector('.mapa');
var selected = (0, _d3Selection.select)(null);

var currentElementZoomed = exports.currentElementZoomed = null; // eslint-disable-line

function mutableCurrentElementZoomed(el) {
  exports.currentElementZoomed = currentElementZoomed = el;
}

function callCloseZoomMap(_ref) {
  var target = _ref.target;

  selected.classed('active', false);
  var key = target.getAttribute('key');
  var isZoom = app.getAttribute('isZoomed');
  if (!key && Boolean(isZoom)) {
    (0, _zoom.unmountZoom)();
    (0, _filters.clearFiltes)();
    app.removeAttribute('isZoomed', '');
  }
}

function restoreMap() {
  var closeZoom = document.querySelector('.controle button');
  closeZoom.onclick = callCloseZoomMap;
}

function callZoomMap(el) {
  selected.classed('active', false);
  selected = (0, _d3Selection.select)(this).classed('active', true);
  app.setAttribute('isZoomed', true);
  mutableCurrentElementZoomed(el);
  (0, _zoom.mountZoom)(el);
}

exports.default = function () {
  (0, _filters2.default)();
  restoreMap();
};

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d = __webpack_require__(153);

var d3 = _interopRequireWildcard(_d);

var _d3Selection = __webpack_require__(9);

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getState = _store2.default.getState;


function createLegend(container, value, scale) {
  function legendCandidatos() {
    var legend = container.selectAll('.legenda').data(value).enter().append('div').attr('class', 'legenda__item');
    legend.append('h5').attr('class', 'legenda__item__nome').text(function (d) {
      return d.nome_candidato.toLowerCase() + ' (' + d.sigla_partido + ')';
    });
    var legendBlock = legend.append('div').attr('class', 'legenda__item__partido');

    // ITEM CONTAINER
    var legendBlockItem = legendBlock.append('div').attr('class', 'partido__item');

    // BLACKGROUND COLOR
    legendBlockItem.append('span').attr('class', 'partido__item__cor').style('background-color', function (d) {
      return scale(d.numero_candidato);
    }).append('span');

    // TEXTO
    legendBlockItem.append('span').attr('class', 'partido__item__legenda').text('Acima de 50%');

    // ITEM CONTAINER
    legendBlockItem = legendBlock.append('div').attr('class', 'partido__item');

    // BLACKGROUND COLOR
    legendBlockItem.append('span').attr('class', 'partido__item__cor').style('background-color', function (d) {
      return scale(d.numero_candidato);
    }).style('opacity', '.5');

    // TEXTO
    legendBlockItem.append('span').attr('class', 'partido__item__legenda').text('Abaixo de 50%');
  }

  function legendIndividual() {
    var width = 200;
    var height = 50;
    var svg = container.append('svg').attr('width', width).attr('height', height);

    // Espacamento das retas
    var x = d3.scaleLinear().domain(scale.domain()).range([0, 40, 80, 120]);

    // Espacamento da label
    var b = d3.scaleLinear().domain(scale.domain()).range([0, 160]);

    var g = svg.append('g')
    // .attr('class', '')
    .attr('transform', 'translate(20,0)').attr('class', 'legend__percent__text');
    g.selectAll('rect')
    // Os dados da scala
    .data(scale.range()) // scale.domain()
    .enter().append('rect').attr('height', 20).attr('x', function (d, i) {
      return x.range()[i];
    }).attr('width', 40)
    // Aplicando 'recursivo'
    //  .style('fill', d => scale(d))
    // .attr('w', d => console.log(scale.invertExtent(d)))
    .style('fill', function (d) {
      return d;
    });

    g.call(d3.axisBottom(b).tickSize(30).tickFormat(function (d) {
      return d + '%';
    }).tickValues(scale.domain())).select('.domain').remove();
  }

  return {
    candidatos: legendCandidatos,
    individual: legendIndividual
  };
}

exports.default = function () {
  var _getState = getState(),
      initial = _getState.initial;

  var param = initial.param,
      data = initial.data,
      list = initial.list;
  var NEWDATA = list.NEWDATA;
  var candidatos = NEWDATA.candidatos;
  var vencedores = data.vencedores;
  var currentKey = param.currentKey,
      currentScale = param.currentScale;
  var tooltip = currentKey.tooltip;

  var individual = document.querySelector('.legenda__candidato');
  if (tooltip === 'individual') {
    var _candidatos$currentKe = candidatos[currentKey.param],
        nome_candidato = _candidatos$currentKe.nome_candidato,
        sigla_partido = _candidatos$currentKe.sigla_partido; // eslint-disable-line

    individual.innerHTML = '<h4 class="candidato__nome">' + nome_candidato.toLowerCase() + ' (' + sigla_partido + ')</h4>'; // eslint-disable-line
  } else {
    individual.innerHTML = '';
  }
  var legendContainer = (0, _d3Selection.select)('.legenda__svg');
  legendContainer.html('');
  var response = createLegend(legendContainer, vencedores, currentScale);
  response[currentKey.tooltip]();
};

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d3Selection = __webpack_require__(9);

var _d3Geo = __webpack_require__(268);

var _index = __webpack_require__(75);

var _events = __webpack_require__(227);

var _mouse = __webpack_require__(873);

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

var _draw = __webpack_require__(875);

var _draw2 = _interopRequireDefault(_draw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = _store2.default.getState,
    dispatch = _store2.default.dispatch;

var main = document.querySelector('main');
var app = (0, _d3Selection.select)('.mapa');
var props = {
  width: main.clientWidth,
  height: main.clientWidth * 0.8
};

function newFill(item) {
  var _getState = getState(),
      initial = _getState.initial;

  var param = initial.param;
  var currentKey = param.currentKey,
      currentScale = param.currentScale;

  if (item.dadosMunicipio) {
    var value = (0, _draw2.default)(item.dadosMunicipio[currentKey.key], currentKey);
    if (value) {
      return currentScale(value);
    }
  }
  return false;
}

// RENDER MAP

exports.default = function () {
  var _getState2 = getState(),
      initial = _getState2.initial;

  var dataGeo = initial.dataGeo,
      listMerge = initial.listMerge,
      scales = initial.scales,
      param = initial.param;
  var estados = dataGeo.estados;
  var width = props.width,
      height = props.height;
  var currentKey = param.currentKey;
  var type = currentKey.type;


  var path = (0, _d3Geo.geoPath)();

  app.append('div').attr('class', 'mapa__tooltip');

  var svg = app.append('svg').attr('class', 'mapa__svg').attr('viewBox', '0 0 ' + width + ' ' + height).attr('preserveAspectRatio', 'xMaxYMin');

  var container = svg.append('g').attr('class', 'mapa__container');

  // DESENHA CADA MUNICIPIO
  var m = container.append('g').attr('class', 'mapa__municipios');

  m.selectAll('.path__municipio').data(listMerge).enter().append('path').attr('d', path).attr('class', 'path__municipio').attr('data-id', function (d) {
    return d.id;
  }).style('fill', function (d) {
    var val = newFill(d);
    if (val) {
      return val;
    }
    return 'transparent';
  }).style('fill-opacity', function (_ref) {
    var dadosMunicipio = _ref.dadosMunicipio;

    if (dadosMunicipio && !type) {
      var candidatos = dadosMunicipio.candidatos;

      if (candidatos.constructor === Array && candidatos.length !== 0) {
        var total_percentual = candidatos[0].total_percentual; // eslint-disable-line

        var retorno = scales.percentual()(parseFloat(total_percentual));
        return retorno;
      }
    }
    return '';
  }).style('stroke-width', 0.03).style('stroke', 'white').on('mouseover', _mouse.handleMouseOver).on('mousemove', _mouse.handleMouseMove).on('mouseout', _mouse.handleMouseOut);

  // DESENHA CADA ESTADO
  var e = container.append('g').attr('class', 'mapa__estados');

  e.selectAll('.path__estado').data([estados]).enter().append('path').attr('d', path).attr('class', 'path__estado').attr('data-uf', function (_ref2) {
    var properties = _ref2.properties;
    return properties.uf;
  }).style('fill', 'red').on('click', _events.callZoomMap);

  dispatch((0, _index.saveElementsStore)({
    container: container,
    path: path,
    props: props
  }));

  // CLICK PATH TRIGGER
  var selectedPath = document.querySelector('.path__estado');
  var eventClick = new Event('click');
  selectedPath.dispatchEvent(eventClick);
};

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  PROS: '#c7588f',
  'PC do B': '#a65062',
  MDB: '#b1640c',
  PSB: '#e6b300',
  PRB: '#edcdab',
  PTB: '#70b7e7',
  PSOL: '#f7df00',
  PT: '#cb613f',
  REDE: '#769887',
  PSL: '#cdcf7d',
  PODE: '#98bc70',
  PDT: '#958476',
  PPS: '#8b79af',
  PP: '#c8bf70',
  DEM: '#4b8196',
  PHS: '#a2b090',
  PSDB: '#1b5595',
  PMB: '#697aa2',
  AVANTE: '#88aeb7',
  PSC: '#008B4B',
  PPL: '#aeaeb3',
  PR: '#cea45c',
  DC: '#597037',
  PRP: '#d4d721',
  PV: '#7a9632',
  SOLIDARIEDADE: '#deb37d',
  PTC: '#e0ddb6',
  PRTB: '#a891bd',
  PMN: '#8cc1ce',
  PSD: '#0087ca',
  PATRI: '#7eaa64',
  PSTU: '#d3807f',
  NOVO: '#d88d19',
  PCO: '#5b5a5d',
  PCB: '#a45524',
  BRANCO: '#9b9b9b',
  NULO: '#424242'
};

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(317);
module.exports = __webpack_require__(519);


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(219);

var _reduxThunk = __webpack_require__(523);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__(524);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default));

exports.default = store;

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

var _main = __webpack_require__(526);

var _main2 = _interopRequireDefault(_main);

__webpack_require__(881);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _main2.default)(_store2.default);

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(219);

var _initial = __webpack_require__(525);

var _initial2 = _interopRequireDefault(_initial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootReducer = (0, _redux.combineReducers)({
  initial: _initial2.default
});

exports.default = rootReducer;

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = initialReducer;

var _ActionTypes = __webpack_require__(220);

var initialState = {
  list: {},
  listMerge: [],
  loading: false,
  elements: null,
  scales: {},
  param: {
    currentKey: null,
    currentScale: null
  },
  dataGeo: {
    municipios: {},
    estados: {}
  },
  data: {
    vencedores: {}
  }
};

function initialReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var type = action.type;

  switch (type) {
    case _ActionTypes.FETCH_SUCCESS:
      return _extends({}, state, {
        loading: true,
        list: action.payload
      });

    case _ActionTypes.SAVE_ELEMENTS_STORE:
      return _extends({}, state, {
        elements: action.payload
      });

    case _ActionTypes.SAVE_SCALES:
      return _extends({}, state, {
        scales: action.payload
      });

    // case CHANGE_PARAMETER_FILTER:
    //   return {
    //     ...state,
    //     filters: {
    //       ...state.filters,
    //       individual: action.payload
    //     },
    //   };

    case _ActionTypes.MERGE_DATA_GEO:
      return _extends({}, state, {
        listMerge: action.payload
      });

    case _ActionTypes.SAVE_DATA:
      return _extends({}, state, {
        data: _extends({}, state.data, {
          vencedores: action.payload.vencedores
        })
      });

    case _ActionTypes.SAVE_DATA_GEO:
      return _extends({}, state, {
        dataGeo: _extends({}, state.dataGeo, {
          municipios: action.payload.municipios,
          estados: action.payload.estados
        })
      });

    case _ActionTypes.CHANGE_CURRENT_KEY:
      return _extends({}, state, {
        param: _extends({}, state.param, { currentKey: action.payload })
      });

    case _ActionTypes.CHANGE_CURRENT_SCALE:
      return _extends({}, state, {
        param: _extends({}, state.param, { currentScale: action.payload })
      });

    default:
      return state;
  }
}

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(75);

var _resultadoGeral = __webpack_require__(535);

var _resultadoGeral2 = _interopRequireDefault(_resultadoGeral);

var _index2 = __webpack_require__(538);

var _index3 = _interopRequireDefault(_index2);

var _scale = __webpack_require__(879);

var _scale2 = _interopRequireDefault(_scale);

__webpack_require__(880);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listPreviusValue = {};
var loadingPreviusValue = null;

function loadingUpdate() {
  var loadingNode = document.querySelector('#loading');
  loadingNode.setAttribute('hidden', true);
}

function init(list) {
  (0, _resultadoGeral2.default)(list.NEWDATA);
  (0, _scale2.default)(list);
  (0, _index3.default)(list);
}

function listenSubscribe(subscribe, getState) {
  subscribe(function () {
    var _getState = getState(),
        initial = _getState.initial;

    var loading = initial.loading,
        list = initial.list;


    if (loadingPreviusValue !== loading) {
      loadingUpdate(loading);
      loadingPreviusValue = loading;
    }

    if (!Object.is(listPreviusValue, list)) {
      listPreviusValue = list;
      init(list);
    }
  });
}

exports.default = function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState,
      subscribe = _ref.subscribe;

  var _getState2 = getState(),
      loading = _getState2.loading;

  if (!loading) {
    dispatch((0, _index.fetchBegin)());
  }
  listenSubscribe(subscribe, getState);
};

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(536);

var _window = window,
    estado = _window.estado,
    turno = _window.turno;
// const numRowsTableOutrosResultados = 5;

var numRowsTableOutrosResultados = 4;

// const urlJson = `https://infograficos-eleicoes-2018.s3.amazonaws.com/oglobo_digital/${estado}/resultado-geral-governador.json`;
var urlPrefix = 'https://infograficos-estaticos.s3.amazonaws.com/eleicao-2018-mapas/governador/rj';
var imgPathPrefix = urlPrefix + '/img/candidatos/governador/' + estado;

var $ = document.querySelector.bind(document);
var $$ = document.querySelectorAll.bind(document);

var tituloSectionResultado = 'O resultado no estado';
tituloSectionResultado = estado.toLowerCase() === 'rj' ? 'O resultado no Rio de Janeiro no primeiro turno' : tituloSectionResultado;
tituloSectionResultado = estado.toLowerCase() === 'sp' ? 'O resultado em São Paulo no primeiro turno' : tituloSectionResultado;
tituloSectionResultado = estado.toLowerCase() === 'mg' ? 'O resultado em Minas Gerais no primeiro turno' : tituloSectionResultado;
tituloSectionResultado = estado.toLowerCase() === 'rs' ? 'O resultado no Rio Grande do Sul no primeiro turno' : tituloSectionResultado;
$('.resultado-geral__titulo').innerHTML = tituloSectionResultado;

//#region FUNCTIONS
// Adiciona ponto a cada 3 digitos em um float e retorna em double
var intWithDots = function intWithDots(n) {
  n = parseInt(n, 10).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return isSafari ? n.substring(2, n.length - 2) : n.substring(3, n.length - 3);
};

// Animacao de contador para um numero inteiro ou float
var animPercent = function animPercent(el, initialNum, finalNum) {
  if (finalNum) {
    if (Number.isInteger(finalNum)) {
      var interval = setInterval(function () {
        el.innerHTML = initialNum + '%';
        initialNum >= finalNum ? clearInterval(interval) : '';
        initialNum++;
      }, 50);
    } else {
      var intInitialNum = Math.floor(initialNum);
      var intFinalNum = Math.floor(finalNum);
      var _interval = setInterval(function () {
        el.innerHTML = intInitialNum + '%';
        if (intInitialNum >= intFinalNum) {
          clearInterval(_interval);
          el.innerHTML = finalNum.toString().replace('.', ',') + '%';
        }
        intInitialNum++;
      }, 50);
    }
  }
};
//#endregion FUNCTIONS


// Altera a navbar e o titulo da section de resultado para o estado atual
$$('.gov-nav__square').forEach(function (el) {
  if (el.innerHTML.toLowerCase() === estado.toLowerCase()) {
    el.classList.add('gov-nav__square--active');
    el.href = 'javascript:void(0)';
  }
});

// Altera o turno selcionado na nav caso seja o turno 2
if (turno === 2) {
  $('.turnos-nav__squares-container').innerHTML = '\n    <a class="turnos-nav__square" href="https://infograficos.oglobo.globo.com/brasil/mapa-eleicao-2018-governador-' + estado + '.html">1\xBA turno</a>\n    <a class="turnos-nav__square turnos-nav__square--active" href="javascript:void(0)">2\xBA turno</a>\n  ';
}

var populateHeader = function populateHeader(data) {
  var Resultado = data;
  // console.log('Resultado', Resultado);
  var cands = [];

  Resultado.total.candidatos.forEach(function (cand) {
    // Somente candidatos validos
    if (cand.total_votos_validos != '0' && Resultado.candidatos[cand.id_candidato].nome_candidato) {
      cands.push({
        num: cand.id_candidato,
        perc: parseFloat(cand.total_percentual.replace(',', '.')),
        vot: parseInt(cand.total_votos_validos.split('.').join(''), 10),
        eleito: Resultado.candidatos[cand.id_candidato].eleito === 'S',
        nome: Resultado.candidatos[cand.id_candidato].nome_candidato.toLowerCase(),
        part: Resultado.candidatos[cand.id_candidato].sigla_partido
      });
    }
  });
  // console.log('cands', cands);

  var votosTotais = parseInt(Resultado.total.total.split('.').join(''), 10);
  var votosBrancos = parseInt(Resultado.total.brancos.split('.').join(''), 10);
  var votosNulos = parseInt(Resultado.total.nulos.split('.').join(''), 10);
  var votosValidos = votosTotais - votosBrancos - votosNulos;
  var percentBrancos = Math.round(votosBrancos * 100 / votosTotais * 100) / 100;
  var percentNulos = Math.round(votosNulos * 100 / votosTotais * 100) / 100;

  var sortedCandidatos = cands.sort(function (a, b) {
    return a.vot < b.vot ? 1 : -1;
  });
  // const sortedCandidatos = cands;

  var $TableOutrosResultados = $('.resultado-geral__outros-resultados');
  var $Top3Candidatos = $$('.candidato-top-3');
  var $Top3Percents = $$('.candidato-top-3__percentual');
  var $LabelEleito = $('.candidato-top-3__legenda-eleito');
  var $LabelsSegundoTurno = $$('.candidato-top-3__legenda-segundo-turno');
  var $ValorTotalUrnas = $('.resultado-urnas-apuradas span');
  var $ValorTotalVotosApurados = $('.resultado-total-votos-apurados span');

  var htmlTableOutrosResultados = '';
  var isTopOfTableOutrosResultados = function isTopOfTableOutrosResultados(n) {
    return (n + 1 - 3 + (numRowsTableOutrosResultados - 1)) % numRowsTableOutrosResultados;
  };
  var isBottomOfTableOutrosResultados = function isBottomOfTableOutrosResultados(n) {
    return (n + 1 - 3) % numRowsTableOutrosResultados;
  };

  // Labels "Eleito" e "Segundo turno"
  if (turno === 1) {
    $LabelsSegundoTurno[0].style.display = 'flex';
    $LabelsSegundoTurno[1].style.display = 'flex';
  } else if (turno === 2) {
    $LabelEleito.style.display = 'flex';
  }

  // Candidatos
  sortedCandidatos.forEach(function (cand, i) {
    var qtdCandHeader = turno === 2 ? 2 : 3;

    if (turno === 2) {}
    // $Top3Candidatos[2].style.display = 'none';
    // $('.resultado-geral__top-3').style.maxWidth = '720px';

    // Top 3
    if (i < qtdCandHeader) {
      var candImg = imgPathPrefix + '/' + cand.num + '.png';
      var silhouetteImg = urlPrefix + '/img/candidatos/silhueta.png';

      $Top3Candidatos[i].querySelector('.candidato-top-3__img > img').src = candImg;

      var img = new Image();
      img.onerror = function () {
        $Top3Candidatos[i].querySelector('.candidato-top-3__img > img').src = silhouetteImg;
      };
      img.src = candImg;

      $Top3Candidatos[i].querySelector('.candidato-top-3__nome').innerHTML = cand.nome.toLowerCase();
      $Top3Candidatos[i].querySelector('.candidato-top-3__partido').innerHTML = cand.part;
      animPercent($Top3Percents[i], 0, cand.perc);
      $Top3Candidatos[i].querySelector('.candidato-top-3__votos').innerHTML = intWithDots(cand.vot) + ' votos';
    }
    // Tabela do 4 em diante
    else if (turno === 1) {
        isTopOfTableOutrosResultados(i) === 0 ? htmlTableOutrosResultados += '<div class="outros-resultados__column">' : '';

        htmlTableOutrosResultados += '\n        <div class="outros-resultados__row">\n          <div class="outros-resultados__nome">' + cand.nome + ' (' + cand.part + ')</div>\n          <div class="outros-resultados__percentual">' + cand.perc.toString().replace('.', ',') + '%</div>\n          <div class="outros-resultados__votos">' + intWithDots(cand.vot) + '</div>\n        </div>\n      ';

        isBottomOfTableOutrosResultados(i) === 0 || i == sortedCandidatos.length - 1 ? htmlTableOutrosResultados += '</div>' : '';
      }
  });
  // Adiciona os brancos, nulos e abstencoes
  htmlTableOutrosResultados += '\n    <div class="outros-resultados__column">\n      <div class="outros-resultados__row">\n        <div class="outros-resultados__nome">Brancos</div>\n        <div class="outros-resultados__percentual">' + (isNaN(percentBrancos) ? 0 : percentBrancos).toString().replace('.', ',') + '%</div>\n        <div class="outros-resultados__votos">' + intWithDots(votosBrancos) + '</div>\n      </div>\n      <div class="outros-resultados__row">\n        <div class="outros-resultados__nome">Nulos</div>\n        <div class="outros-resultados__percentual">' + (isNaN(percentNulos) ? 0 : percentNulos).toString().replace('.', ',') + '%</div>\n        <div class="outros-resultados__votos">' + intWithDots(votosNulos) + '</div>\n      </div>\n      <!--\n      <div class="outros-resultados__row">\n        <div class="outros-resultados__nome">Absten\xE7\xF5es</div>\n        <div class="outros-resultados__percentual">0%</div>\n        <div class="outros-resultados__votos">0</div>\n      </div>\n      -->\n    </div>\n  ';
  // Append no HTML
  $TableOutrosResultados.innerHTML = htmlTableOutrosResultados;

  // Totais de urnas e votos
  // $ValorTotalUrnas.innerHTML = `${Resultado.urnaA.toString().replace(/\./g, ',')}%`;
  // $ValorTotalVotosApurados.innerHTML = intWithDots(Resultado.totalApu);
  $ValorTotalUrnas.innerHTML = Resultado.atualizacao.apuracao_total;
  $ValorTotalVotosApurados.innerHTML = Resultado.total.total;
};

exports.default = populateHeader;

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// import { append } from '../../helpers/append';

// CSS


exports.default = createMap;

var _topojsonClient = __webpack_require__(539);

var _index = __webpack_require__(75);

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

var _events = __webpack_require__(227);

var _events2 = _interopRequireDefault(_events);

var _render = __webpack_require__(314);

var _render2 = _interopRequireDefault(_render);

var _legend = __webpack_require__(234);

var _legend2 = _interopRequireDefault(_legend);

__webpack_require__(877);

__webpack_require__(878);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var dispatch = _store2.default.dispatch,
    getState = _store2.default.getState;


function order(item) {
  return _extends({}, item, {
    candidatos: [].concat(_toConsumableArray(item.candidatos.sort(function (a, b) {
      return parseInt(b.total_votos_validos.replace(/\D/g, ''), 10) - parseInt(a.total_votos_validos.replace(/\D/g, ''), 10);
    })))
  });
}

function createMap(_ref) {
  var NEWDATA = _ref.NEWDATA,
      MAP = _ref.MAP;

  var todosMunicipios = (0, _topojsonClient.feature)(MAP, MAP.objects.tracts);
  var todosEstados = (0, _topojsonClient.feature)(MAP, MAP.objects.ufs);
  var features = todosEstados.features;

  // UF DO RIO - GEO

  var estados = features.find(function (_ref2) {
    var id = _ref2.id;
    return id === '35';
  });

  // MUNICIPIOS DO RIO - GEO
  var municipios = todosMunicipios.features.filter(function (_ref3) {
    var properties = _ref3.properties;
    return properties.uf === 'SP';
  });

  // MERGE GEO + DADO
  var newMunicipios = municipios.map(function (e) {
    var id = e.id;

    var item = NEWDATA.municipios[id];
    return _extends({}, e, { dadosMunicipio: order(item) });
  });

  // 'GRAVA' O MERGE e GEO
  dispatch((0, _index.mergeDataGeo)(newMunicipios));
  dispatch((0, _index.saveDataGeo)({
    municipios: municipios,
    estados: estados
  }));

  // INICIAR COM ESSES PARAMETROS (KEY, SCALE)
  console.log('@@@ INICIO');

  var _getState = getState(),
      initial = _getState.initial;

  var scales = initial.scales;
  var scaleCandidatos = scales.scaleCandidatos;


  dispatch((0, _index.changeCurrentKey)({
    key: 'candidatos',
    target: 'id_candidato',
    type: null,
    tooltip: 'candidatos'
  }));

  dispatch((0, _index.changeCurrentScale)(scaleCandidatos()));
  console.log('@@@ RENDER MAPA');
  (0, _render2.default)();
  console.log('@@@ RENDER LEGENDA');
  (0, _legend2.default)();
  console.log('@@@ START EVENTS');
  (0, _events2.default)();
}

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mountZoom = mountZoom;
exports.unmountZoom = unmountZoom;

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { zoom } from 'd3-zoom'; // eslint-disable-line
// import { zoomParameters } from '../../actions/index';

var getState = _store2.default.getState;

// function zoomed() {
//   const { initial } = getState();
//   const { elements } = initial;
//   const {
//     context,
//     props,
//   } = elements;
//   const { transform } = d3.event;

//   context.save();
//   context.clearRect(0, 0, props.width, props.height);
//   context.translate(transform.x, transform.y);
//   context.scale(transform.k, transform.k);
//   draw({ strokeStyle: '#000', lineWidth: 0.1 });
//   context.restore();
// }

// const zoomI = zoom().scaleExtent([1, 10]).on('zoom', zoomed);

// import draw from './draw';

function mountZoom(event) {
  var _getState = getState(),
      initial = _getState.initial;

  var elements = initial.elements;
  var container = elements.container,
      path = elements.path,
      props = elements.props;


  var bounds = path.bounds(event);
  var dx = bounds[1][0] - bounds[0][0];
  var dy = bounds[1][1] - bounds[0][1];
  var x = (bounds[0][0] + bounds[1][0]) / 2;
  var y = (bounds[0][1] + bounds[1][1]) / 2;
  var scale = 0.9 / Math.max(dx / props.width, dy / props.height);
  var translate = [props.width / 2 - scale * x, props.height / 2 - scale * y];
  // dispatch(zoomParameters({ scale, translate }));

  // const { canvas } = context;
  container
  // .transition()
  // .duration(750)
  .attr('transform', 'translate(' + translate + ') scale(' + scale + ')');

  // container.select('.path__fronteira')
  //   .style('stroke', '#fff')
  //   .style('stroke-width', `${3 / scale}px`);

  // MÉTODO COM TRANSIÇÃO
  // select(canvas)
  //   .transition()
  //   .duration(750)
  //   .call(
  //     zoomI.transform,
  //     d3.zoomIdentity
  //       .translate(translate[0], translate[1])
  //       .scale(scale)
  //   );
  // MÉTODO SEM TRANSIÇÃO
  // context.save();
  // context.clearRect(0, 0, props.width, props.height);
  // context.translate(translate[0], translate[1]);
  // context.scale(scale, scale);
  // // draw({ strokeStyle: '#000', lineWidth: 0.2 });
  // context.restore();
}

function unmountZoom() {
  var _getState2 = getState(),
      initial = _getState2.initial;

  var elements = initial.elements;
  var container = elements.container;

  container.attr('transform', '');
  container.select('.path__fronteira').style('stroke', '#000').style('stroke-width', '1');
  // draw();
}

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearFiltes = clearFiltes;

var _d3Selection = __webpack_require__(9);

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

var _index = __webpack_require__(75);

var _dict = __webpack_require__(582);

var _dict2 = _interopRequireDefault(_dict);

var _legend = __webpack_require__(234);

var _legend2 = _interopRequireDefault(_legend);

var _render = __webpack_require__(314);

var _render2 = _interopRequireDefault(_render);

var _util = __webpack_require__(876);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getState = _store2.default.getState,
    dispatch = _store2.default.dispatch;

var filters = document.querySelector('.filtros');
var filterLeft = filters.querySelector('.filtros__esquerda');
var filterRight = filters.querySelector('.filtros__direita');

exports.default = function () {
  var _getState = getState(),
      initial = _getState.initial;

  var list = initial.list,
      scales = initial.scales;
  var NEWDATA = list.NEWDATA;
  var municipios = NEWDATA.municipios,
      candidatos = NEWDATA.candidatos,
      total = NEWDATA.total;

  // TEMPLATE

  var appendVencedores = function appendVencedores(param) {
    return param.map(function (item, i) {
      return (i === 0 ? '<option value="">Selecione um candidato</option>' : '') + '\n          <option value=' + item.numero_candidato + '>\n            ' + item.nome_candidato + ' (' + item.sigla_partido + ')\n          </option>';
    }).join('');
  };

  // TEMPLATE
  var appendMunicipios = function appendMunicipios(param) {
    return Object.keys(param).map(function (item, i) {
      return (i === 0 ? '<option value="">Selecione um município</option>' : '') + '\n      <option value=' + item + '>' + param[item].municipio + '</option>';
    }).join('');
  };

  // HANDLER
  function handlerLeft(_ref) {
    var target = _ref.target;

    var attr = target.getAttribute('tipo');
    var value = target.value;

    var active = document.querySelector('.path__municipio.active');
    if (active) {
      active.classList.remove('active');
    }

    if (attr === 'municipio' && value) {
      var pathActive = document.querySelector('[data-id=\'' + value + '\']');
      (0, _d3Selection.select)(pathActive).dispatch('mouseover').dispatch('mousemove');
      (0, _util.scroll)('.geografia__voto__container');
    }

    if (!value) {
      var over = new Event('mouseout');
      active.dispatchEvent(over);
    }
  }

  // HANDLER
  function handlerRight(_ref2) {
    var target = _ref2.target;
    var value = target.value;

    var app = document.querySelector('.mapa');
    var key = target.getAttribute('key');
    var scaleCandidatos = scales.scaleCandidatos;


    if (!value) {
      dispatch((0, _index.changeCurrentKey)({
        key: 'candidatos',
        target: 'id_candidato',
        type: null,
        tooltip: 'candidatos'
      }));
      dispatch((0, _index.changeCurrentScale)(scaleCandidatos()));
      app.innerHTML = '';
      (0, _render2.default)();
      (0, _legend2.default)();
      return;
    }

    dispatch((0, _index.changeCurrentKey)({
      key: 'candidatos',
      target: 'total_percentual',
      type: 'individual',
      param: value,
      tooltip: 'individual'
    }));

    dispatch((0, _index.changeCurrentScale)((0, _dict2.default)(key)));
    app.innerHTML = '';
    (0, _render2.default)();
    (0, _legend2.default)();
  }

  // EVENT LISTENER
  var leftItem = filterLeft.querySelectorAll('select');
  [].concat(_toConsumableArray(leftItem)).forEach(function (item) {
    item.addEventListener('change', handlerLeft);
  });

  // EVENT LISTENER
  var rightItem = filterRight.querySelectorAll('select');
  [].concat(_toConsumableArray(rightItem)).forEach(function (item) {
    item.addEventListener('change', handlerRight);
  });

  // FILL FILTERS

  var removed = total.candidatos.filter(function (item) {
    return parseInt(item.total_votos_validos, 10);
  });
  var newCandidatos = removed.map(function (item) {
    return candidatos[item.id_candidato];
  }).sort(function (a, b) {
    return a.nome_candidato.localeCompare(b.nome_candidato);
  });
  filterLeft.querySelector('select[tipo=municipio]').innerHTML = appendMunicipios(municipios);
  filterRight.querySelector('select[tipo=candidato]').innerHTML = appendVencedores(newCandidatos);
};

function clearFiltes() {
  var allInputs = filterLeft.querySelectorAll('select, input');
  [].concat(_toConsumableArray(allInputs)).forEach(function (item) {
    item.value = '';
    var tipo = item.getAttribute('tipo');
    if (tipo !== 'uf') {
      item.setAttribute('disabled', true);
    }
  });
}

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (word) {
  var getState = _store2.default.getState;

  var _getState = getState(),
      initial = _getState.initial;

  var scales = initial.scales;
  var scaleCandidatos = scales.scaleCandidatos,
      scaleIndividual = scales.scaleIndividual;

  var dictionary = {
    candidatos: scaleCandidatos,
    individual: scaleIndividual
  };

  if (dictionary[word]) {
    return dictionary[word]();
  }

  return word;
};

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBegin = exports.fetchFailure = exports.fetchSuccess = exports.changeCurrentScale = exports.saveScales = exports.changeCurrentKey = exports.saveDataGeo = exports.saveData = exports.mergeDataGeo = exports.saveElementsStore = undefined;

var _d3Fetch = __webpack_require__(221);

var _ActionTypes = __webpack_require__(220);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // eslint-disable-line
// import { appendBrancosNulos, appendBrancosNulosComoCandidato } from '../helpers/append';


var saveElementsStore = exports.saveElementsStore = function saveElementsStore(context) {
  return {
    type: _ActionTypes.SAVE_ELEMENTS_STORE,
    payload: context
  };
};

var mergeDataGeo = exports.mergeDataGeo = function mergeDataGeo(data) {
  return {
    type: _ActionTypes.MERGE_DATA_GEO,
    payload: data
  };
};

var saveData = exports.saveData = function saveData(obj) {
  return {
    type: _ActionTypes.SAVE_DATA,
    payload: obj
  };
};

var saveDataGeo = exports.saveDataGeo = function saveDataGeo(obj) {
  return {
    type: _ActionTypes.SAVE_DATA_GEO,
    payload: obj
  };
};

var changeCurrentKey = exports.changeCurrentKey = function changeCurrentKey(key) {
  return {
    type: _ActionTypes.CHANGE_CURRENT_KEY,
    payload: key
  };
};

var saveScales = exports.saveScales = function saveScales(scales) {
  return {
    type: _ActionTypes.SAVE_SCALES,
    payload: scales
  };
};

var changeCurrentScale = exports.changeCurrentScale = function changeCurrentScale(scale) {
  return {
    type: _ActionTypes.CHANGE_CURRENT_SCALE,
    payload: scale
  };
};

// export const changeParameterFilter = value => ({
//   type: CHANGE_PARAMETER_FILTER,
//   payload: value,
// });

var fetchSuccess = exports.fetchSuccess = function fetchSuccess(data) {
  return {
    type: _ActionTypes.FETCH_SUCCESS,
    payload: data
  };
};

var fetchFailure = exports.fetchFailure = function fetchFailure(error) {
  return {
    type: _ActionTypes.FETCH_FAILURE,
    payload: error
  };
};

var fetchBegin = exports.fetchBegin = function fetchBegin() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var _window, estado, MAP, NEWDATA;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _window = window, estado = _window.estado;
              _context.next = 4;
              return (0, _d3Fetch.json)('https://deoliyp60f2gq.cloudfront.net/eleicao-2018-mapas/governador/rj/json/brasil.json');

            case 4:
              MAP = _context.sent;
              _context.next = 7;
              return (0, _d3Fetch.json)('https://infograficos-estaticos.s3.amazonaws.com/eleicao-2018-mapas/governador/sp/governador_sp.json');

            case 7:
              NEWDATA = _context.sent;

              // REMOVER ESSA LÓGICA DAQUI
              // const list = { NEWDATA, MAP };
              // const appenNewCandidatos = appendBrancosNulosComoCandidato(list);
              // const newListA = {
              //   ...list,
              //   NEWDATA: {
              //     ...appenNewCandidatos,
              //   },
              // };
              // const appendNewList = appendBrancosNulos(newListA);
              // const newListFinally = {
              //   ...list,
              //   NEWDATA: {
              //     ...appendNewList,
              //   },
              // };
              dispatch(fetchSuccess({ NEWDATA: NEWDATA, MAP: MAP }));
              // dispatch(fetchSuccess(newListFinally));
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

              dispatch(fetchFailure(_context.t0));

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleMouseOver = handleMouseOver;
exports.handleMouseMove = handleMouseMove;
exports.handleMouseOut = handleMouseOut;

var _d3Selection = __webpack_require__(9);

var _d = __webpack_require__(153);

var d3 = _interopRequireWildcard(_d);

var _tooltip = __webpack_require__(874);

var funTooltip = _interopRequireWildcard(_tooltip);

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getState = _store2.default.getState;

var app = document.querySelector('.mapa');

function validate(event) {
  // Se não tem evento, é possível que tenha sido Trigger
  if (!event.pageX || !event.pageY) {
    var active = document.querySelector('.path__municipio.active');
    var parent = document.querySelector('.mapa__container');
    var tooltipH = document.querySelector('.mapa__tooltip').clientHeight;
    var offsetLeft = app.offsetLeft;
    // POSIÇÃO DO PATH EM RELAÇÃO AO VIEWPORT

    var _active$getBoundingCl = active.getBoundingClientRect(),
        x = _active$getBoundingCl.x,
        y = _active$getBoundingCl.y,
        width = _active$getBoundingCl.width;
    // POSIÇÃO DO PARENT PATH EM RELAÇÃO AO VIEWPORT


    var _parent$getBoundingCl = parent.getBoundingClientRect(),
        parentY = _parent$getBoundingCl.y;

    var offsetX = x - (offsetLeft - width);
    var offsetY = y - (parentY - tooltipH / 2 - 20);
    return {
      offsetX: offsetX,
      offsetY: offsetY
    };
  }
  return event;
}

function handleMouseOver(_ref) {
  var dadosMunicipio = _ref.dadosMunicipio;

  var _getState = getState(),
      initial = _getState.initial;

  var param = initial.param;
  var currentKey = param.currentKey;

  var active = document.querySelector('.path__municipio.active');
  if (active) {
    active.classList.remove('active');
  }
  (0, _d3Selection.select)('.mapa__tooltip').style('pointer-events', 'none').style('opacity', '1').html(funTooltip[currentKey.tooltip](dadosMunicipio, currentKey));
  (0, _d3Selection.select)(this.parentNode.appendChild(this)).classed('active', true);
}

function handleMouseMove() {
  var _document$querySelect = document.querySelector('.mapa__tooltip'),
      clientWidth = _document$querySelect.clientWidth;

  var _validate = validate(d3.event),
      offsetY = _validate.offsetY,
      offsetX = _validate.offsetX;
  // console.log('pageX', pageX);
  // console.log('pageY', pageY);
  // const { offsetLeft, offsetTop } = app;
  // console.log('offsetLeft', offsetLeft);
  // console.log('offsetTop', offsetTop);
  // console.log('@@@ pageY - offsetTop', pageY - offsetTop);


  var xRect = void 0;
  var yRect = void 0;
  var sizeScreen = window.screen.availWidth - clientWidth;
  // const sizeMouse = clientWidth + pageX;
  var sizeMouse = clientWidth + offsetX;

  if (sizeMouse < sizeScreen) {
    // xRect = pageX - offsetLeft;
    xRect = offsetX;
    // yRect = pageY - offsetTop; // TUDO ISSO É IGUAL AO d3.offsetY
    yRect = offsetY;
  } else {
    // xRect = pageX - (offsetLeft + clientWidth);
    xRect = offsetX - clientWidth;
    // yRect = pageY - offsetTop;
    yRect = offsetY;
  }
  (0, _d3Selection.select)('.mapa__tooltip').style('transform', 'translate(' + (xRect + 20) + 'px, ' + (yRect + 20) + 'px)');
}

function handleMouseOut() {
  (0, _d3Selection.select)('.mapa__tooltip').style('pointer-events', 'none').style('opacity', '0');

  (0, _d3Selection.select)(this).classed('active', false);
}

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.individual = exports.candidatos = undefined;

var _partidos = __webpack_require__(315);

var _partidos2 = _interopRequireDefault(_partidos);

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function tmpCandidatos(e) {
  var getState = _store2.default.getState;

  var _getState = getState(),
      initial = _getState.initial;

  var list = initial.list;
  var NEWDATA = list.NEWDATA;
  var candidatos = NEWDATA.candidatos;


  if (!e.candidatos) {
    return false;
  }
  var newArr = [].concat(_toConsumableArray(e.candidatos.slice(0, 3)));

  var listaCandidatos = function listaCandidatos(arr) {
    return arr.map(function (_ref) {
      var id_candidato = _ref.id_candidato,
          total_percentual = _ref.total_percentual,
          total_votos_validos = _ref.total_votos_validos;
      return (// eslint-disable-line
        '<div class="lista__candidatos__item">\n        <span class="candidato__grupo">\n          <span style="background-color: ' + _partidos2.default[candidatos[id_candidato].sigla_partido] + '" class="candidato__grupo__partido"></span>\n          <h3 class="candidato__grupo__nome">' + candidatos[id_candidato].nome_candidato.toLowerCase() + ' (' + candidatos[id_candidato].sigla_partido + ')</h3>\n        </span>\n        <span>' + total_percentual + '</span>\n        <span>' + total_votos_validos + '</span>\n      </div>'
      );
    }).join('');
  };
  return ' \n    <div class="tooltip__container">\n      <header class="tooltip__header">\n        <h2>' + e.municipio + '</h2>\n      </header>\n      <div class="tooltip__body">\n        <div class="lista__candidatos">\n          <div class="lista__candidatos__topo">\n            <span>Candidatos</span>\n            <span>% do total</span>\n            <span>N\xBA de votos</span>\n          </div>\n          <div class="lista__candidatos__dados">\n            ' + listaCandidatos(newArr) + '\n          </div>\n        </div>\n      </div>\n      <footer class="tooltip__footer">\n        <p></p>\n      </footer>\n    </div>\n  ';
}

// TEMPLATE INDIVIDUAL
function tmpIndividual(e, currentKey) {
  var getState = _store2.default.getState;

  var _getState2 = getState(),
      initial = _getState2.initial;

  var list = initial.list;
  var NEWDATA = list.NEWDATA;
  var candidatos = NEWDATA.candidatos;
  var param = currentKey.param;

  if (!e.candidatos) {
    return false;
  }
  var candidatoData = e.candidatos.find(function (_ref2) {
    var id_candidato = _ref2.id_candidato;
    return id_candidato === param;
  }); // eslint-disable-line
  if (!candidatoData) return '';
  return ' \n    <div class="tooltip__container">\n      <header class="tooltip__header">\n        <h2>' + e.municipio + '</h2>\n      </header>\n      <div class="tooltip__body">\n        <div class="lista__candidatos">\n          <div class="lista__candidatos__topo">\n            <span>Candidatos</span>\n            <span>% do total</span>\n            <span>N\xBA de votos</span>\n          </div>\n          <div class="lista__candidatos__dados">\n            <div class="lista__candidatos__item">\n            <span class="candidato__grupo">\n              <span style="background-color: ' + _partidos2.default[candidatos[param].sigla_partido] + '" class="candidato__grupo__partido"></span>\n              <h3 class="candidato__grupo__nome">' + candidatos[param].nome_candidato.toLowerCase() + ' (' + candidatos[param].sigla_partido + ')</h3>\n            </span>\n            <span>' + candidatoData.total_percentual + '</span>\n            <span>' + candidatoData.total_votos_validos + '</span>\n          </div>\n          </div>\n        </div>\n      </div>\n      <footer class="tooltip__footer">\n        <p></p>\n      </footer>\n    </div>\n  ';
}

exports.candidatos = tmpCandidatos;
exports.individual = tmpIndividual;

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handlerCurrentKey;
function handlerCurrentKey(arr, options) {
  var type = options.type,
      param = options.param,
      target = options.target;

  /* INDIVIDUAL */

  if (type === 'individual' && arr.length !== 0) {
    var item = arr.find(function (_ref) {
      var id_candidato = _ref.id_candidato;
      return id_candidato === param;
    }); // eslint-disable-line
    if (item) {
      var replace = item[target].replace(/%/g, '').replace(/,/, '.');
      return parseFloat(replace);
    }
    return null;
  }

  if (type === 'individual' && arr.length === 0) {
    return null;
  }

  /* VENCEDORES */
  if (arr.constructor === Array && arr.length !== 0) {
    return arr[0][target];
  }

  if (arr.constructor === Array && arr.length === 0) {
    return null;
  }

  return arr;
}

// export default (options = {}) => {
//   const { getState } = store;
//   const { initial } = getState();
//   const { listMerge, elements } = initial;
//   const { param } = initial;
//   const { currentKey, currentScale } = param;
//   const { context, props, path } = elements;
//   context.clearRect(0, 0, props.width, props.height);
//   listMerge.forEach((item) => {
//     if (item.dadosMunicipio) {
//       const value = handlerCurrentKey(item.dadosMunicipio[currentKey.key], currentKey);
//       if (value && value !== 'BRANCO' && value !== 'NULO') {
//         const color = currentScale(value);
//         // console.log('@@@ color', color);
//         // console.log('@@@ value', value);
//         // console.log('');
//         context.fillStyle = `${color}`;
//         context.strokeStyle = options.strokeStyle || color;
//         context.lineWidth = options.lineWidth || 0;
//         context.beginPath();
//         path(item);
//         context.stroke();
//         context.fill();
//         // context.closePath();
//       }
//     }
//   });
// };

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var d = exports.d = function d() {};

var getParameter = exports.getParameter = function getParameter(arr, key) {
  return arr.map(function (e) {
    return e[key];
  }).filter(function (item, index, self) {
    return self.indexOf(item) === index;
  });
};

var scroll = exports.scroll = function scroll(el) {
  var target = document.querySelector(el);
  var offsetTop = target.offsetTop;
  // const c = document.documentElement.scrollTop || document.body.scrollTop;

  window.scrollTo(0, offsetTop);
  // const smoothScroll = element =>
  //   document.querySelector(element).scrollIntoView({
  //     behavior: 'smooth',
  //   });
  // smoothScroll(el);
};

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 878:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d = __webpack_require__(153);

var d3 = _interopRequireWildcard(_d);

var _d3Scale = __webpack_require__(290);

var _index = __webpack_require__(75);

var _store = __webpack_require__(38);

var _store2 = _interopRequireDefault(_store);

var _partidos = __webpack_require__(315);

var _partidos2 = _interopRequireDefault(_partidos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// import { hotFixAppend } from '../../helpers/append';

var dispatch = _store2.default.dispatch,
    getState = _store2.default.getState;

exports.default = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var NEWDATA = _ref.NEWDATA;
    var municipios, candidatosVencedores, quantidade, posicao, vencedores, desempenho, scales;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log('@@@ in SCALE NEWDATA', NEWDATA);

            municipios = Object.keys(NEWDATA.municipios).map(function (item) {
              return NEWDATA.municipios[item];
            });
            candidatosVencedores = municipios.filter(function (_ref3) {
              var candidatos = _ref3.candidatos;
              return candidatos;
            }).map(function (_ref4) {
              var candidatos = _ref4.candidatos;
              return candidatos ? candidatos[0] : null;
            }).sort(function (a, b) {
              return parseInt(b.total_votos_validos.replace(/\D/g, ''), 10) - parseInt(a.total_votos_validos.replace(/\D/g, ''), 10);
            });
            quantidade = candidatosVencedores.reduce(function (prev, curr) {
              prev[curr.id_candidato] = prev[curr.id_candidato] || [];
              prev[curr.id_candidato].push(parseInt(curr.total_votos_validos.replace(/\D/g, ''), 10));
              return prev;
            }, {});
            posicao = Object.keys(quantidade).map(function (id) {
              var total = quantidade[id].reduce(function (prev, curr) {
                return prev + curr;
              }, 0);
              return {
                id: id,
                total: total
              };
            }).sort(function (a, b) {
              return b.total - a.total;
            });

            // const idVencedores = candidatosVencedores
            //   .map(item => item.id_candidato)
            //   .filter((el, index, arr) => arr.indexOf(el) === index);

            // const vencedores = idVencedores.map(item => NEWDATA.candidatos[item]);

            vencedores = posicao.map(function (item) {
              return NEWDATA.candidatos[item.id];
            });

            // APPEND NULOS E BRANCOS
            // const newMunicipios = hotFixAppend(municipios);

            // PARA PEGAR O MENOR E MAIOR VOTACAO

            desempenho = municipios.filter(function (_ref5) {
              var candidatos = _ref5.candidatos;
              return candidatos;
            }).map(function (_ref6) {
              var candidatos = _ref6.candidatos;
              return candidatos;
            }).reduce(function (prev, curr) {
              return [].concat(_toConsumableArray(prev), _toConsumableArray(curr));
            }, []).reduce(function (prev, curr) {
              prev[curr.id_candidato] = prev[curr.id_candidato] || [];
              prev[curr.id_candidato].push(curr);
              return prev;
            }, {});
            scales = {
              scaleCandidatos: function scaleCandidatos() {
                var range = vencedores.map(function (_ref7) {
                  var sigla_partido = _ref7.sigla_partido;
                  return _partidos2.default[sigla_partido];
                }); // eslint-disable-line
                var domain = vencedores.map(function (_ref8) {
                  var numero_candidato = _ref8.numero_candidato;
                  return numero_candidato;
                }); // eslint-disable-line
                return (0, _d3Scale.scaleOrdinal)().domain(domain).range(range);
              },
              percentual: function percentual() {
                return (0, _d3Scale.scaleThreshold)().domain([50]).range([0.6, 1]);
              },
              scaleIndividual: function scaleIndividual() {
                var _getState = getState(),
                    initial = _getState.initial;

                var param = initial.param;
                var currentKey = param.currentKey;
                var id_candidato = currentKey.param; // eslint-disable-line

                var candidatos = NEWDATA.candidatos;

                var sigla = candidatos[id_candidato].sigla_partido;
                var color = d3.rgb(_partidos2.default[sigla]);
                var r = color.r,
                    g = color.g,
                    b = color.b;

                var start = 'rgba(' + r + ', ' + g + ', ' + b + ', 1)';
                var end = 'rgba(' + r + ', ' + g + ', ' + b + ', 0.35)';
                var colors = d3.quantize(d3.interpolateRgb(start, end), 4);
                var minMax = d3.extent(desempenho[id_candidato], function (e) {
                  return parseFloat(e.total_percentual.replace(/%/g, '').replace(/,/, '.'));
                });
                console.log('minMax', minMax);
                return (0, _d3Scale.scaleQuantize)().domain(minMax).range(colors.reverse());
              }
            };


            dispatch((0, _index.saveScales)(scales));
            dispatch((0, _index.saveData)({ vencedores: vencedores }));

            console.log('@@@ FIM SCALE');
            console.log('');

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[316]);


// WEBPACK FOOTER //
// app.js?1a495a35664306035ef1